import React from 'react';
// import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// import Link from 'shared/components/Link';
import { normalizeLink } from 'shared/modules';
import BreadcrumbsLinks from 'shared/components/BreadcrumbsLinks/BreadcrumbsLinks';
import { uppercaseFirst } from 'shared/helpers/strings';

// import JsonLdApplication from 'shared/components/JsonLdApplication/JsonLdApplication';

import s from './Micromarking.css';

// const AB_PATH = 'https://ab.ua';

// const SpanLink = ({ text, index, intl }) =>
//   <span>
//     {index === 0
//       ? replaceToUpperCase(intl.formatMessage({ id: text }))
//       : intl.formatMessage({ id: text })}
//   </span>;

// SpanLink.propTypes = {
//   text: PropTypes.string.isRequired,
//   index: PropTypes.number.isRequired,
//   intl: intlShape.isRequired,
// };

class Micromarking extends React.Component {
  static propTypes = {
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    history: PropTypes.shape({
      currentPath: PropTypes.string,
    }),
    globals: PropTypes.shape({
      seoSearchUrlResponse: PropTypes.object,
    }),
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    history: {
      currentPath: '',
    },
    globals: {
      seoSearchUrlResponse: {},
    },
  };

  render() {
    const { globals: { seoSearchUrlResponse }, history: { currentPath }, intl, title } = this.props;

    const {
      usd_price: usdPrice = null,
      offers_count: offersCount = null,
      newness_category: newCat,
    } = seoSearchUrlResponse;

    const urlArr = currentPath.split('/').filter(Boolean).filter(a => !/\?/.test(a));
    const obj = {
      gruzovye: 'gruzovye',
      avtobus: 'avtobus',
      pritsepy: 'pritsepy',
      spetstehnika: 'spetstehnika',

      zapchasti: 'zapchasti',
      avtosalony: 'avtosalony',
      'katalog-kompaniy': 'katalog-kompaniy',
    };
    // const hasQuery = !!currentPath.split('').find(item => item === '?');

    const urlData = [['/', 'Автобазар', 'avtobazar']];
    const locale = intl.formatMessage({ id: 'locale' });

    if (locale === 'ru') urlArr.unshift('ru');

    const avtoTitle = newCat === 'new' ? 'Новые авто' : 'БУ авто';
    const setUrls = {};
    Object.keys(seoSearchUrlResponse).map(a => {
      for (let a1 = 0, b1 = urlArr.length; a1 < b1; a1 += 1) {
        // eslint-disable-next-line no-continue
        if (setUrls[urlArr[a1]]) continue;
        if (seoSearchUrlResponse[a] && urlArr[a1] === seoSearchUrlResponse[a].slug) {
          if (
            typeof seoSearchUrlResponse[a].title === 'string' ||
            typeof seoSearchUrlResponse[a].name === 'string'
          ) {
            const linkTitle =
              urlArr[a1] === 'avto'
                ? avtoTitle
                : seoSearchUrlResponse[a].title || seoSearchUrlResponse[a].name;
            const url = urlArr[a1] === 'avto' && newCat === 'new' ? urlArr[a1 + 1] : urlArr[a1];
            urlData.push([
              normalizeLink(url, { url: currentPath, defaul: `/${urlArr[0]}/` }),
              linkTitle,
              url,
            ]);
            setUrls[urlArr[a1]] = 1;
          }
        } else if (obj[urlArr[a1]]) {
          let titleUrl = '';
          if (urlArr[a1] === obj.zapchasti) {
            titleUrl = intl.formatMessage({ id: 'avtozapchasti' });
          } else {
            titleUrl = intl.formatMessage({ id: urlArr[a1] });
          }

          urlData.push([
            normalizeLink(urlArr[a1], { url: currentPath, defaul: `/${urlArr[0]}/` }),
            uppercaseFirst(titleUrl),
            urlArr[a1],
          ]);
          setUrls[urlArr[a1]] = 1;
        }
      }
      return '';
    });
    // console.log('urlData >>> ', urlData);
    // const breadcrumbItemListEl = urlData.map((a, b) => ({
    //   '@type': 'ListItem',
    //   position: b + 1,
    //   item: {
    //     '@id': `${AB_PATH}${a[0]}/`,
    //     name:
    //       b === 0
    //         ? replaceToUpperCase(intl.formatMessage({ id: a[1] }))
    //         : intl.formatMessage({ id: a[1] }),
    //   },
    // }));

    // const breadcrumbListLd = {
    //   '@context': 'http://schema.org',
    //   '@type': 'BreadcrumbList',
    //   itemListElement: breadcrumbItemListEl,
    // };

    return (
      <div>
        {/* <div className={cx(s.olNavigationLink)}>
          {urlData.map((a, b) =>
            <span className={s.itemListElement} key={`${b}${a[2]}`}>
              {b + 1 === urlData.length && !hasQuery
                ? <span className={'meta-title-link-next'}>
                    <SpanLink text={a[1]} index={b} intl={intl} />
                  </span>
                : <li>
                    <Link
                      itemProp="url"
                      to={`${a[0]}/`}
                      className={cx({
                        'meta-title-link': b === 0,
                        'meta-title-link-next': b !== 0,
                      })}
                    >
                      <SpanLink text={a[1]} index={b} intl={intl} />
                    </Link>
                  </li>}
            </span>,
          )}
        </div>
        <JsonLdApplication {...breadcrumbListLd} /> */}
        <BreadcrumbsLinks links={urlData} />
        {usdPrice &&
          <div vocab="https://schema.org/" typeof="Product" className={s.displayNone}>
            <span property="name">
              {title}
            </span>
            <span property="offers" typeof="AggregateOffer">
              <span property="offerCount">{offersCount}</span>
              От <span property="lowPrice">{usdPrice.min}</span>$ до{' '}
              <span property="highPrice">{usdPrice.max}</span>$
              <meta property="priceCurrency" content="USD" />
            </span>
          </div>}
      </div>
    );
  }
}

const mapStateToProps = ({ history, globals }) => ({ history, globals });

export default withStyles(s)(connect(mapStateToProps)(injectIntl(Micromarking)));



// WEBPACK FOOTER //
// ./src/shared/components/Micromarking/Micromarking.js